import { object } from "prop-types";
import { ResponsiveImage } from "@quintype/components";
import React from "react";

import { SvgIconHandler } from "../../../../atoms/svg-icon-hadler";
import ScrollSnap from "../../../../molecules/ScrollSnap";

import "./slideshow-element.m.css";

const SlideshowElement = ({ element }) => {
  const children = element["story-elements"].map((item, index) => (
    <div key={index}>
      <figure className="blank-story-image" styleName="qt-image-16x9">
        <ResponsiveImage
          slug={item["image-s3-key"]}
          aspectRatio={[16, 9]}
          imgParams={{ auto: ["format", "compress"], fmt: "webp" }}
          alt={item["image-attribution"] || item.title || ""}
        />
      </figure>
      {item.title && (
        <>
          <figcaption styleName="caption" dangerouslySetInnerHTML={{ __html: item.title }} />
          {item["image-attribution"] && (
            <span styleName="attribute" dangerouslySetInnerHTML={{ __html: `${item["image-attribution"]}` }} />
          )}
        </>
      )}
    </div>
  ));

  return (
    <div styleName="wrapper">
      <ScrollSnap
        leftArrow={
          <SvgIconHandler iconStyle={{ color: "#fff" }} type="rightarrow" width="10" height="18" viewBox="0 0 10 18" />
        }
        rightArrow={
          <SvgIconHandler iconStyle={{ color: "#fff" }} type="rightarrow" width="10" height="18" viewBox="0 0 10 18" />
        }
      >
        {children}
      </ScrollSnap>
    </div>
  );
};

SlideshowElement.propTypes = {
  element: object,
};

export default SlideshowElement;
